export default "__VITE_ASSET__Cws_YE4u__"